module.exports = "/assets/data/72cb405d24b69ef6cd9a7d102afde153-CH49.data.json";